export default "__VITE_ASSET__VCKHcGvL__"